import React from 'react';
import { Link } from 'react-router-dom';
import SocialNetworks from '../global/SocialNetworks';
import "./Footer.css"

export default function Footer() {

  return (
    <footer id="footer">
      <div className="footer-content">
        <div className="contact-info">
          <h4>יום מעשים טובים מטעם עמותת רוח טובה המציעה התנדבות בהתאמה אישית כל השנה</h4>
          <address>שדרות שאול המלך 21, בית שאול, תל אביב-יפו</address>
          <div className="developed-by" aria-label="Arison"></div>
        </div>

        <div className="footer-social" style={{marginTop: '25px'}}>
          <SocialNetworks />
        </div>

        <div className="footer-menu" style={{marginTop: '25px'}}>
          <h2>השתתפו</h2>
          <ul>
            <li><Link to="/volunteer">התנדבות אישית או עם קבוצה</Link></li>
            <li><Link to="/businesses">חברות ועסקים</Link></li>
            <li><Link to="/project">עמותות וארגונים</Link></li>
            <li><Link to="/local_authorities">רשויות מקומיות</Link></li>
          </ul>
        </div>

        <div className="footer-menu" style={{marginTop: '25px'}}>
          <h2>יום מעשים טובים</h2>
          <ul>
            <li><Link to="/about">אודות</Link></li>
            <li><Link to="/press">אנחנו בתקשורת</Link></li>
            <li><Link to="/contact">צרו קשר</Link></li>
            <li><Link to="/terms">תנאי שימוש</Link></li>
            <li><Link to="/privacy">מדיניות פרטיות</Link></li>
            <li><Link to="/sitemap">מפת אתר</Link></li>
            <li><Link to="/accessibility">הצהרת נגישות</Link></li>
            <li><a href="https://www.arisongroup.com/" target="_blank" rel="noopener noreferrer">קבוצת אריסון</a></li>
            <li><Link to="/gddtshirts">חולצות יום מעשים טובים</Link></li>
            <li><Link to="/faming">FAMING#</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  )
}
